<template>
  <div class="modal" :class="{ 'is-active': show }" v-if="show">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Documents</p>
      </header>
      <section class="modal-card-body">
        <document-uploader :can-pick-from-lib="canPickFromLib" :company-job-key="companyJobKey" :freight-key="freightKey" v-model="documents" />
      </section>
      <footer class="modal-card-foot columns is-centered">

        <div class="column is-half">
          <button class="button is-fullwidth is-success" @click="addDocuments">Close</button>
        </div>

      </footer>
    </div>
  </div>
</template>

<script>
import DocumentUploader from '@/components/DocumentUploader'
import { isEqual } from 'lodash-es'
export default {
  name: 'DocumentUploadModal',

  props: {
    show: {
      type: Boolean
    },
    canPickFromLib: {
      type: Boolean,
      default: true
    },
    companyJobKey: {
      type: String
    },
    freightKey: {
      type: String
    },
    value: {
      type: Array,
      default: () => []
    }
  },

  created() {
    this.documents = [...this.value]
  },

  data() {
    return {
      documents: []
    }
  },

  components: {
    DocumentUploader
  },

  methods: {
    close() {
      this.$emit('update:show', false)
    },

    addDocuments() {
      if (!isEqual(this.documents, this.value)) {
        this.$emit('input', this.documents)
      }

      this.close()
    }
  }
}
</script>

<style scoped>
</style>
